import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { IListOfficerState, LIST_OFFICER_STORE_KEY } from './list-officer-store.state';

const state = createFeatureSelector<IListOfficerState>(LIST_OFFICER_STORE_KEY);

export const officerState = createSelector(state, (state1: IListOfficerState) => state1);
export const officer = createSelector(state, (state1: IListOfficerState) => state1.officers);
export const paginationOfficers = createSelector(state, (state1: IListOfficerState) => state1.paginationOfficers);
export const filteredOfficersTotalCount = createSelector(state, (state1: IListOfficerState) => state1.filteredOfficersTotalCount);
export const actionResult = createSelector(state, (state1: IListOfficerState) => state1.actionResult);
export const officerQuery = createSelector(state, (state1: IListOfficerState) => state1.query);
export const isLoadingOfficers = createSelector(state, (state1: IListOfficerState) => state1.isLoading);
export const isInvitingUser = (uid: string): MemoizedSelector<IListOfficerState, boolean> =>
  createSelector(state, (state1: IListOfficerState) => state1.officers.some((o) => o.uid === uid && o.isInviting));
export const orgChartOfficers = createSelector(state, (state1) => state1.orgChartOfficers);
